module.exports = __webpack_public_path__ + "static/media/university-ucat.6417a51c.jpg";